const DEFAULT_CONTRACTING_MODALITY = 'VMR - Valor de Mercado Referenciado';
const VD_CONTRACTING_MODALITY = 'VD - Valor Determinado';

const LEGACY_CONTRACTING_MODALITY_DEFINITION = {
  title: 'Valor determinado:',
  description:
    'É a modalidade de seguro, que garante ao Segurado, no caso de indenização integral, roubo ou furto do veículo, o pagamento de quantia fixa, em moeda corrente nacional, conforme o LMI-Limite Máximo de Indenização e Fator de Ajuste estabelecidos no ato da contratação e independentemente do valor de mercado do veículo quando da ocorrência do sinistro.',
};

const VD_CONTRACTING_MODALITY_DEFINITION = {
  title: 'VALOR DETERMINADO (VD)',
  description:
    'É a modalidade que garante ao SEGURADO(A), no caso de indenização integral, o pagamento de quantia fixa, em moeda corrente nacional, estipulada pelas partes no ato da contratação do seguro.',
};

const VMR_CONTRACTING_MODALITY_DEFINITION = {
  title: 'VALOR DE MERCADO REFERENCIADO (VMR)',
  description:
    'É a modalidade que garante ao SEGURADO(A), no caso de Indenização Integral, o pagamento de quantia variável, em moeda corrente nacional, determinada de acordo com a Tabela de Referência (FIPE), previamente fixada na Proposta de Seguro, conjugada com o fator de ajuste, em percentual, a ser aplicado sobre o valor de cotação do veículo na Tabela de Referência, na data da ocorrência do sinistro.',
};

export const getContractingModality = (payload) =>
  typeof payload?.contractingModality === 'string' && payload.contractingModality.trim()
    ? payload.contractingModality
    : DEFAULT_CONTRACTING_MODALITY;

export const getContractingModalityDefinition = (payload) => {
  if (payload?.capabilities?.showFipeBasedContractingModality !== true) {
    return LEGACY_CONTRACTING_MODALITY_DEFINITION;
  }

  const contractingModality = payload?.contractingModality;
  if (contractingModality === VD_CONTRACTING_MODALITY) return VD_CONTRACTING_MODALITY_DEFINITION;
  if (contractingModality === DEFAULT_CONTRACTING_MODALITY) return VMR_CONTRACTING_MODALITY_DEFINITION;

  return LEGACY_CONTRACTING_MODALITY_DEFINITION;
};
